<div class="card mb-3" (click)="openAuctionManagePage(auction.id, $event)" >
  <div class="row">
    <div class="col col-3">
        <img
        [src]="img"
        alt="Auction Campaign Image"
        class="img-fluid rounded-start"
        style="height: 110px; width: 220px; border-radius: 4px;"
        />
    </div>
    <div class="col col-9 d-flex justify-content-between flex-column">
      <div class="row d-flex align-items-center justify-content-start mb-2 ">
        <div class="col d-flex align-items-center">
          <h5 class="subtitle-1 mb-0">{{auction.name}}</h5>
          <i class="fas fa-chevron-right ml-2 pointer"></i>
        </div>
        <div class="col col-5">
          <ng-container [ngSwitch]="getAuctionStatus()">
              <div class="d-flex flex-column">
                <span class="body-2 text-right mb-1">Expected Proceeds</span>
                <span class="green-text headline-6 text-right">{{getNumberStr(auction.campaignTypeData.expectedProceed)}}</span>
              </div>
            <ng-container *ngSwitchCase="3">OnlineBiddingNotEnabled</ng-container>
            <ng-container *ngSwitchCase="4">OnlineBiddingTypeLive</ng-container>
          </ng-container>
        </div>
      </div>
      <div class="row pl-2 d-flex justify-content-between action-row">
        <div class="d-flex align-items-center h-100 col-4">
          <div [innerHTML]="statusHTML" style="display: contents;">   
          </div>
          <span class="body-2 ml-2 ">{{auction.campaignTypeData.presetOptions.length }} items</span>
        </div>
        <div class=" col-8 h-100 actions-list-wrapper ">
          <ul class="d-flex flex-row list-group actions-list justify-content-end h-100"  style="min-height: 36px;">
            <li 
                    *ngIf="auction.campaignTypeData.auctionType === 0 && auctionStatus !== 2" 
                    (click)="onPauseResumeClick(auction)"
                    class="list-group-item list-group-item--auction d-flex mr-3 cursor--pointer noDetaisClick p-0 px-2"
                    style="border-radius: 5px;align-items: center;">
                      <ng-container [ngSwitch]="auctionStatus">
                        <i *ngSwitchCase="1" class="fas fa-play"></i>
                        <i *ngSwitchCase="0" class="fas fa-pause"></i>
                      </ng-container>
                      <span class="noDetaisClick ml-1 pointer expanded-text ml-1">{{auctionStatus == 1 ? 'Start Bidding Now...': 'Stop Bidding Now...'}}</span>
            </li>
            <li 
                  *ngIf="auction.campaignTypeData.auctionType === 0" 
                  [ngClass]="getAuctionStatus() !== 2 ? 'cursor--pointer': '' " 
                  (click)="onStopClick(auction)" 
                  class="list-group-item list-group-item--auction d-flex mr-3 noDetaisClick" 
                  style="border-radius: 5px;padding: 0px 10px!important;align-items: center;">
              <ng-container [ngSwitch]="auctionStatus">
                <ng-container *ngSwitchCase="0">
                  <i class="fas fa-stop fa-sm noDetaisClick" style="color: #ff0512;"></i>
                  <span class="noDetaisClick ml-1 pointer expanded-text">Close Auction Now...</span>
                </ng-container>
                <ng-container *ngSwitchCase="1">
                  <i class="fas fa-stop fa-sm noDetaisClick" style="color: #ff0512;"></i>
                  <span class="noDetaisClick ml-1 pointer expanded-text">Close Auction Now...</span>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                  <i class="fas fa-stop fa-sm disabled noDetaisClick" style="color: grey;"></i>
                  <span class="noDetaisClick ml-1 pointer grey-text p-0 expanded-text">Auction has ended</span>
                </ng-container>
              </ng-container>
  
            </li>
            <li 
              class="list-group-item list-group-item--auction d-flex p-0 cursor--pointer noDetaisClick" 
              title="Download Reports & Bid Sheets" 
              style="border-radius: 5px;align-items: center;"
              (mouseenter)="isDownloadHovered = true" 
              (mouseleave)="isDownloadHovered = false" 
              [ngClass]="isDownloadHovered ? 'pr-2' : '' "  >
              <app-auctions-popover [auction]="auction" class="noDetaisClick">
                <span *ngIf="isDownloadHovered" class="noDetaisClick ml-1 pointer body-1">Download Reports & Bid Sheets</span>
              </app-auctions-popover>    
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</div>
